export const GET_DOCTOR_DASHBOARD = "GET_DOCTOR_DASHBOARD";

export const getDoctorDashboard = (dashboardData) => {
  return {
    type: GET_DOCTOR_DASHBOARD,
    payload: dashboardData,
  };
};
